import { render, staticRenderFns } from "./CoursesAndSeminars.vue?vue&type=template&id=78a9ccdf&"
import script from "./CoursesAndSeminars.vue?vue&type=script&lang=js&"
export * from "./CoursesAndSeminars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports